export const APP_NAME = 'Trợ Lý TikTok AI';
export const API_BASE_FALLBACK = 'http://127.0.0.1:8787';
export const BOTTOM_NAV_ITEMS = [
    { key: 'tong-quan', label: 'Tổng quan', icon: '🏠' },
    { key: 'kenh', label: 'Kênh', icon: '📺' },
    { key: 'ai', label: 'AI', icon: '✨' },
    { key: 'video', label: 'Video', icon: '🎬' },
    { key: 'lich-dang', label: 'Lịch đăng', icon: '🗓️' },
    { key: 'thu-vien', label: 'Thư viện', icon: '🗂️' },
    { key: 'cai-dat', label: 'Cài đặt', icon: '⚙️' }
];
export const CONTENT_TYPES = ['idea', 'script', 'caption', 'hashtag', 'prompt', 'video', 'analysis'];
export const CHANNEL_STATUSES = ['chinh', 'phu', 'tam_dung'];
export const VIDEO_STATUSES = ['nhap', 'da_xuat', 'cho_dang', 'da_dang'];
export const SCHEDULE_STATUSES = ['cho_dang', 'da_dang', 'hoan'];
export const LIBRARY_STATUSES = ['nhap', 'da_luu', 'cho_render', 'da_render', 'cho_dang', 'da_dang', 'da_dung', 'yeu_thich'];
export const VIDEO_STYLES = [
    'điện ảnh',
    'thực tế',
    'chill buồn',
    'truyền cảm hứng',
    'quote tâm trạng',
    'học sinh / tuổi trẻ',
    'healing',
    'phố đêm',
    'POV',
    'ánh sáng neon',
    'mưa đêm',
    'cô đơn',
    'trưởng thành'
];
export const IDEA_VIDEO_TYPES = [
    'quote',
    'storytelling',
    'cinematic',
    'vlog giả lập',
    'POV',
    'động lực',
    'buồn',
    'học sinh',
    'healing',
    'bắt trend kiểu nhẹ'
];
export const CAPTION_TYPES = [
    'caption buồn',
    'caption storytelling',
    'caption ngắn kiểu viral',
    'caption động lực',
    'caption chill',
    'caption mở tranh luận nhẹ',
    'caption CTA'
];
export const QUICK_CHAT_PROMPTS = [
    'Tạo 10 idea',
    'Viết caption buồn',
    'Viết hook viral',
    'Tạo prompt video cinematic',
    'Lên lịch 7 ngày',
    'Phân tích kênh này',
    'Gợi ý video kéo follow',
    'Gợi ý nội dung tăng tim',
    'Tóm tắt tình trạng kênh',
    'Gợi ý 3 việc nên làm hôm nay'
];
